import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useStorage } from '~Components/Storage';
import { useButton } from '~Hooks';
import { Button } from '~Styles';

const ButtonWrapper = styled(Button)<{ isBusy?: boolean }>`
  background-color: ${({ isBusy }) => (isBusy ? 'var(--colorUIOrange)' : 'var(--colorUIGreen)')};
  color: white;
`;

interface Props {
  poiid: string;
  handleSetupPayment: (poiid: string) => void;
  closeSelector: () => void;
  isbusy?: boolean;
}

const AdyenTerminalButton: FC<Props> = ({ poiid, handleSetupPayment, closeSelector, isbusy }) => {
  const [storage] = useStorage();

  const adyenTerminalSelectButton = useButton({
    onClick: () => {
      closeSelector();
      handleSetupPayment(poiid);
    },
  });

  const getTerminalName = (id: string) => {
    const terminal = storage.terminalNames.find((t) => t.id === id);
    return terminal ? terminal.name : id;
  };

  return (
    <ButtonWrapper {...adyenTerminalSelectButton} fluid style={{ height: '56px' }} isBusy={isbusy}>
      {(isbusy ? '(BUSY) ' : '') + (getTerminalName(poiid) || poiid)}
    </ButtonWrapper>
  );
};

export default AdyenTerminalButton;
